import { fgFilterEntries } from "@redotech/redo-fulfillment-operations-common/views/fulfillment/fg-filter-catalog";
import { AdvancedFilterType } from "@redotech/redo-views-common/advanced-filters/generic-advanced-filter-data";
import { AdvancedTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";
import { fulfillmentGroupCreateTagLabel } from "../fulfillment-group-tag-ui-copy";

export function augmentFgFiltersWithTagCreate(
  filters: AdvancedTableFilter[],
  onRequestCreateTag: () => void,
  valueFetcherRefreshKey?: number,
): AdvancedTableFilter[] {
  const tagFilterName = fgFilterEntries.tagName.name;
  return filters.map((filter) => {
    if (
      filter.type !== AdvancedFilterType.ARRAY_TO_STRING ||
      filter.data.name !== tagFilterName
    ) {
      return filter;
    }
    return {
      ...filter,
      onRequestCreateItem: onRequestCreateTag,
      createItemText: () => fulfillmentGroupCreateTagLabel,
      valueFetcherRefreshKey,
    };
  });
}
